import BaseApiAction from '@Actions/base-api-action';

export default class InviteUserToTeam extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-inviteUserToTeam',
      payload: {
        team_id: this._payload.team_id,
        email: this._payload.email,
      },
      disableLoaders: true
    });
  }
}
